import { get } from 'lodash/fp';
import { connect } from 'react-redux';

import FallbackLoader from './FallbackLoader';

const mapStateToProps = (state) => {
  const selectedEstimateId = get('estimateBuilder.uiState.selectedEstimate')(state);

  return ({
    selectedEstimate: get(`estimateBuilder.entities.estimates.byId[${selectedEstimateId}]`)(state),
  });
};
export default connect(mapStateToProps)(FallbackLoader);
